import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useShallow } from "zustand/react/shallow";

import styles from "./styles.module.scss";
import type { IWalletProps } from "./types";

import { Typography } from "@/components/atoms/typography";
import type { IBalance } from "@/api/walletBalance/types";
import { Icon } from "@/components/atoms/icons";
import { path } from "@/routes/path";
import { useUserStore } from "@/stores/userStore";

export function Wallet(props: IBalance & IWalletProps) {
  const { t } = useTranslation("common");
  const navigate = useNavigate();
  const id = useUserStore(useShallow((state) => state.id));
  // TODO: ADD LOADER

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <Icon type={"linear"} name={"WalletMoney"} color={"primary-main"} />
        <Typography
          color={"primary-main"}
          fontSize={"md-high"}
          fontWeight={"medium"}
        >
          {t("walletBalance")}
          {":\r"}
        </Typography>
        <Typography
          color={"primary-main"}
          fontSize={"base"}
          fontWeight={"semi-bold"}
        >
          {props.balance}
        </Typography>
      </div>
      <div className={styles.buttonContainer}>
        {!props.noWithdraw && (
          <div
            className={styles.button}
            onClick={() => navigate(path.walletBalance.withdraw.link())}
          >
            <Icon name={"CardSend"} type={"linear"} color={"primary-main"} />
            <Typography
              color={"primary-main"}
              fontSize={"md-high"}
              fontWeight={"medium"}
            >
              {t("deposit")}
            </Typography>
          </div>
        )}
        {!props.noDeposit && (
          <div
            className={styles.button}
            onClick={() =>
              navigate(path.walletBalance.deposit.link(id.toString()))
            }
          >
            <Icon name={"CardRecive"} type={"linear"} color={"success-main"} />
            <Typography
              color={"success-main"}
              fontSize={"md-high"}
              fontWeight={"medium"}
            >
              {t("withdraw")}
            </Typography>
          </div>
        )}
      </div>
    </div>
  );
}
